import gift from '@/assets/images/play/gift.png';
import message from '@/assets/images/play/message.png';
import Modal from '@/components/Modal';
import { trackUserAction } from '@/utils/gtag';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import { FC, useState } from 'react';

interface Props {
    bubuName: string;
    isClaiming: boolean;
    claimMessage: (type?: 'gift') => Promise<void>;
    className?: string;
}

export const WelcomeGiftModal: FC<Props> = ({
    bubuName,
    isClaiming,
    claimMessage,
    className,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => {
        setIsOpen(true);
        trackUserAction('open_welcome_gift_modal', 'user_interaction', {
            bubu_name: bubuName,
        });
    };

    return (
        <div className={className}>
            <button
                className="bg-success text-[14px] text-white px-[20px] py-[10px] rounded-[16px]"
                onClick={openModal}
            >
                Open your welcome gift
            </button>
            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="Welcome gift!"
            >
                <div className="font-semibold my-[30px]">
                    Congrats for the birth of {bubuName}
                </div>
                <div className="flex justify-between items-center">
                    <img src={gift} className="w-[60px] mx-[25px]" />
                    <AddIcon />
                    <img src={message} className="w-[60px] mx-[25px]" />
                </div>
                <div className="flex justify-between mt-[20px] font-semibold">
                    <div className="w-[110px] text-center">50</div>
                    <div className="w-[110px] text-center">20</div>
                </div>
                <div className="flex justify-between text-[12px]">
                    <div className="w-[110px] text-center">extra messages</div>
                    <div className="w-[110px] text-center">
                        regular messages
                    </div>
                </div>
                <div className="text-[12px] text-center text-gray mt-[30px]">
                    Remember to use them all in 24 hours
                </div>
                <button
                    className="bg-primary text-[14px] text-white w-full py-[10px] rounded-[8px] mt-[30px]"
                    onClick={() => claimMessage('gift')}
                >
                    {isClaiming ? (
                        <div className="flex justify-center items-center gap-[10px]">
                            <span>Claiming...</span>
                            <RefreshIcon className="w-[16px] animate-spin" />
                        </div>
                    ) : (
                        'Claim'
                    )}
                </button>
            </Modal>
        </div>
    );
};
